import { DataService } from "@/services/data";
import { PaginatedResponse } from "@/types/common";
import { FundingOrganismType } from "@/types/content/funding_organism";
import { ProductType } from "@/types/content/product";
import { ProductSessionType } from "@/types/content/product_session";
import { TrackInstanceType } from "@/types/content/track_instance";
import { FundingOrganismSessionType } from "@/types/content/registration/funding_organism_session";
import { ProfessionDisplayType } from "@/types/content/registration/profession";
import { RouteObject } from "react-router-dom";

const PicklistsRoute: RouteObject = {
    path: "picklists",
    children: [
        {
            path: "funding_organisms",
            loader: async () => {
                const funding_organisms = (await DataService.client.url(`/content/funding_organisms?page_size=1000`).get().json()) as PaginatedResponse<FundingOrganismType>;
                return funding_organisms.results;
            }
        },
        {
            path: "opco",
            loader: async () => {
                const opcos = (await DataService.client.url(`/content/funding_organisms/?type=opco&page_size=1000`).get().json()) as PaginatedResponse<FundingOrganismType>;
                return opcos.results;
            }
        },
        {
            path: "products",
            loader: async ({ request }) => {
                const url = new URL(request.url);
                const products = (await DataService.client.url(`/content/products/?${url.searchParams.toString()}`).get().json()) as PaginatedResponse<ProductType>;
                return products.results;
            }
        },
        {
            path: "funding_organism_sessions",
            loader: async ({ request }) => {
                const url = new URL(request.url);
                const sessions = (await DataService.client.url(`/content/funding_organism_sessions/?${url.searchParams.toString()}`).get().json()) as PaginatedResponse<FundingOrganismSessionType>;
                return sessions.results;
            }
        },
        {
            path: "product_sessions",
            loader: async ({ request }) => {
                const url = new URL(request.url);
                const sessions = (await DataService.client.url(`/content/product_sessions/?${url.searchParams.toString()}`).get().json()) as PaginatedResponse<ProductSessionType>;
                return sessions.results;
            }
        },
        {
            path: "track_instances",
            loader: async ({ request }) => {
                const url = new URL(request.url);
                const instances = (await DataService.client.url(`/content/track_instances/?${url.searchParams.toString()}`).get().json()) as PaginatedResponse<TrackInstanceType>;
                return instances.results;
            }
        },
        {
            path: "professions",
            loader: async () => {
                const professions = (await DataService.client.url(`/content/professions/?page_size=100`).get().json()) as PaginatedResponse<ProfessionDisplayType>;
                return professions.results;
            }
        }
    ]
};
export default PicklistsRoute;
